import React from 'react';
import PropTypes from 'prop-types';

import useUserData from 'data-hooks/useUserData';
import ImageWithTextBanner2 from '../image-with-text-banner2';

const SalesBanner = props => {
  const { isTradeUser } = useUserData();

  // hide sale info for trade user
  const config = isTradeUser
    ? {
        ...props.config,
        textContent: {
          ...props.config.textContent,
          disclaimer: '',
          title: '',
          icon: '',
        },
      }
    : props.config;

  return <ImageWithTextBanner2 {...props} config={config} />;
};

SalesBanner.propTypes = {
  data: PropTypes.object,
  config: PropTypes.shape({
    textContent: PropTypes.shape({
      title: PropTypes.string,
      disclaimer: PropTypes.string,
      icon: PropTypes.string,
    }),
  }),
};

export default SalesBanner;
